export default "__VITE_ASSET__FGK9lv5w__"